var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxSelect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.5,9C16.5,13.1421,13.1421,16.5,9,16.5C4.8578600000000005,16.5,1.5,13.1421,1.5,9C1.5,4.8578600000000005,4.8578600000000005,1.5,9,1.5C13.1421,1.5,16.5,4.8578600000000005,16.5,9ZM15.375,9Q15.375,7.78401,14.9274,6.6534Q14.4414,5.42579,13.5078,4.49219Q12.5742,3.5586,11.3466,3.0726Q10.21599,2.625,9,2.625Q7.78401,2.625,6.6534,3.0726Q5.42579,3.5586,4.49219,4.49219Q3.5586,5.42579,3.0726,6.6534Q2.625,7.78401,2.625,9Q2.625,10.21599,3.0726,11.3466Q3.5586,12.5742,4.49219,13.5078Q5.42579,14.4414,6.6534,14.9274Q7.78401,15.375,9,15.375Q10.21599,15.375,11.3466,14.9274Q12.5742,14.4414,13.5078,13.5078Q14.4414,12.5742,14.9274,11.3466Q15.375,10.21599,15.375,9Z",
    fillRule: "evenodd",
    fill: "#FF4747",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9,
    cy: 9,
    rx: 3.75,
    ry: 3.75,
    fill: "#FF4747",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxSelect);
export default __webpack_public_path__ + "media/box_select.57a72fac.svg";
export { ForwardRef as ReactComponent };